<template>
  <div>
    <el-dialog
        title="Bitrate Info (last event)"
        width="60%"
        top="10px"
        :visible.sync="visible">
      <div style="padding: 0px 10px 20px 10px;">
        <div v-if="loadingBitRate">
          <div style="text-align: center;">
            <i class="el-icon-loading"></i> Looking last event and loading bitrate information...
          </div>
        </div>
        <div v-else>
          <div v-if="error">
            <div style="color: red; text-align: center;">
              {{ error }}
            </div>
          </div>
          <div v-else>
            <div style="text-align: center;">
              <h2 style="margin: 0px;">
                {{ currentEvent.type | uppercase }} - {{ currentEvent.ding_id }}
              </h2>
              <h3 style="margin: 0px;">
                {{ currentEvent.created_at | moment("MMMM Do YYYY, h:mm a") }}
              </h3>
            </div>
            <div style="overflow: scroll;">
              <el-row :gutter="20">
                <el-col
                    v-for="(value, key) in bitrateData"
                    :key="key"
                    :span="24 ">
                  <el-link
                      :href="'data:image/svg+xml;base64,' + value"
                      target="_blank">
                    <img
                        :src="'data:image/svg+xml;base64,' + value"
                        style="width: 100%;">
                  </el-link>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-button
        slot="reference"
        plain
        :type="visible ? 'info' : 'success'"
        size="mini"
        style="margin-right: 5px; min-width: 100%;"
        @click="visible = !visible">
      Bitrate
    </el-button>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: deviceActions } = createNamespacedHelpers("db/device");

export default {
  name: "BitrateInfo",
  props: {
    device: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      visible: false,
      loadingBitRate: true,
      currentEvent: {},
      bitrateData: {},
      error: null,
    };
  },
  watch: {
    visible: function (value) {
      console.log("Visible is", value);
      if (value) this.showLastBitrate();
    },
  },
  methods: {
    ...deviceActions(["getLastBitrate"]),
    showLastBitrate() {
      this.loadingBitRate = true;
      this.getLastBitrate({
        doorbotId: this.device.doorbot_id,
      })
        .then((response) => {
          this.currentEvent = response.data.event;
          this.bitrateData = response.data.images;
          this.loadingBitRate = false;
        })
        .catch((error) => {
          console.log("Error loading bitrate", error);
          this.loadingBitRate = false;
          this.$message.error(
            error.data.message || "Information not available."
          );
          this.visible = false;
        });
    },
  },
};
</script>
